import type { INavItem } from "app/components/React/SideNavComponents/SideNav.types";
import {
    COMPANY_ANALYSIS_CONTACTS,
    COMPANY_ANALYSIS_OVERVIEW,
    WEBSITE_ANALYSIS_PERFORMANCE,
} from "app/pages/sales-intelligence/constants/routes";

import createCompanyPageNavItem from "../../../company/configuration/navItemFactory";

import type { PagesRecord } from "./types";

export default function createAccountOverviewPagesService() {
    const KNOWN_PAGES: PagesRecord = {
        company: COMPANY_ANALYSIS_OVERVIEW,
        contacts: COMPANY_ANALYSIS_CONTACTS,
        website: WEBSITE_ANALYSIS_PERFORMANCE,
    };

    function getPageStateKey(name: keyof PagesRecord): string {
        return KNOWN_PAGES[name];
    }

    /**
     * An array of navigation items objects needed to build the left menu navigation
     */
    const navItems: INavItem[] = [
        createCompanyPageNavItem(getPageStateKey("company")),
    ];

    return {
        getPageStateKey,
        getNavItems() {
            return navItems;
        },
    };
}
